export function Marquee({ items }: { items: readonly string[] }) {
  const track = [...items, ...items];
  return (
    <section className="v2-marquee" aria-label={items.join(', ')}>
      <div className="v2-marquee-track" aria-hidden="true">
        {track.map((item, index) => (
          <span className="v2-marquee-item" key={`${item}-${index}`}>
            {item}
            <i className="v2-marquee-star">✦</i>
          </span>
        ))}
      </div>
    </section>
  );
}
